cityWaterRate={
    "北京": 72.00010733068585,
    "天津": 99.99922887701359,
    "河北": 94.55355782016176,
    "石家庄市": 94.19999296542507,
    "晋州市": 99.78510028653295,
    "新乐市": 100.0,
    "唐山市": 98.24655923984913,
    "滦州市": 93.04029304029304,
    "遵化市": 89.10809699958898,
    "迁安市": 96.0,
    "秦皇岛市": 98.23696399223067,
    "邯郸市": 100.0,
    "武安市": 92.95207410390657,
    "邢台市": 93.2536293766012,
    "南宫市": 100.0,
    "沙河市": 99.99999999999997,
    "保定市": 91.17919075144509,
    "涿州市": 98.52411807055435,
    "安国市": 79.8913043478261,
    "高碑店市": 93.70242214532873,
    "白沟新城": 97.50812567713976,
    "张家口市": 99.06733818317478,
    "承德市": 100.0,
    "平泉市": 98.5180794309425,
    "沧州市": 100.0,
    "泊头市": 100.0,
    "任丘市": 100.0,
    "黄骅市": 100.0,
    "河间市": 100.0,
    "廊坊市": 99.07955292570676,
    "霸州市": 77.59009009009009,
    "三河市": 82.30452674897118,
    "衡水市": 95.2129313024557,
    "深州市": 91.14583333333331,
    "辛集市": 96.54519640321817,
    "定州市": 20.81230473443884,
    "山西": 92.29906187159636,
    "太原市": 100.0,
    "古交市": 87.36196319018404,
    "大同市": 73.97862979258328,
    "阳泉市": 82.82717595491546,
    "长治市": 95.38950715421302,
    "潞城市": 91.57894736842105,
    "晋城市": 94.37751004016064,
    "高平市": 99.84848484848484,
    "朔州市": 91.82216079244414,
    "晋中市": 99.7867803837953,
    "介休市": 61.17858749437697,
    "运城市": 99.0,
    "永济市": 87.71929824561404,
    "河津市": 35.45454545454545,
    "忻州市": 91.93548387096774,
    "原平市": 93.10710498409331,
    "临汾市": 99.3517017828201,
    "侯马市": 100.0,
    "霍州市": 100.0,
    "吕梁市": 98.92473118279571,
    "孝义市": 96.31632308212234,
    "汾阳市": 90.01636661211128,
    "内蒙古": 97.88441360998694,
    "呼和浩特市": 99.37415426251692,
    "包头市": 100.0,
    "乌海市": 100.0,
    "赤峰市": 93.45794392523365,
    "通辽市": 98.30434782608695,
    "霍林郭勒市": 95.63886763580719,
    "鄂尔多斯市": 99.84917043740573,
    "呼伦贝尔市": 94.17808219178082,
    "满洲里市": 99.05749293119699,
    "牙克石": 90.14404852160729,
    "扎兰屯市": 97.17261904761905,
    "额尔古纳市": 96.3157894736842,
    "根河市": 94.68749999999999,
    "巴彦淖尔市": 98.04432855280312,
    "乌兰察布市": 96.57622739018088,
    "丰镇市": 96.03174603174604,
    "乌兰浩特市": 88.11009174311927,
    "阿尔山市": 98.53556485355648,
    "二连浩特": 100.0,
    "锡林浩特市": 97.94608472400515,
    "辽宁": 97.14454723784421,
    "沈阳市": 95.31603907134767,
    "新民市": 79.51247823563551,
    "大连市": 100.0,
    "瓦房店市": 100.0,
    "庄河市": 99.82758620689654,
    "鞍山市": 100.0,
    "海城市": 95.71078431372548,
    "抚顺市": 99.71393543114017,
    "本溪市": 99.68641114982579,
    "丹东市": 99.23664122137403,
    "东港市": 100.0,
    "凤城市": 99.48105864037366,
    "锦州市": 100.0,
    "凌海市": 100.0,
    "北镇市": 73.35483870967742,
    "营口市": 100.0,
    "盖州市": 88.96581566421462,
    "大石桥市": 100.0,
    "阜新市": 98.76218066894917,
    "辽阳市": 100.0,
    "灯塔市": 83.53156450137237,
    "盘锦市": 100.0,
    "铁岭市": 98.5294117647059,
    "调兵山市": 25.740650801359884,
    "开原市": 100.0,
    "朝阳市": 97.2904318374259,
    "北票市": 95.10869565217392,
    "凌源市": 98.21428571428572,
    "葫芦岛市": 96.06147934678194,
    "兴城市": 89.15304606240713,
    "吉林": 90.64586511803401,
    "长春市": 93.70508326029798,
    "榆树市": 83.54131534569983,
    "德惠市": 92.57812499999999,
    "吉林市": 97.95130407375305,
    "蛟河市": 86.3052781740371,
    "桦甸市": 92.99442033477992,
    "舒兰市": 69.85491671144545,
    "磐石市": 97.799511002445,
    "四平市": 94.65855307640298,
    "双辽市": 85.47008547008548,
    "辽源市": 95.35591157980126,
    "通化市": 94.469746258946,
    "集安市": 97.84810126582279,
    "白山市": 89.38271604938272,
    "临江市": 98.24380165289256,
    "松原市": 96.10228913177976,
    "扶余市": 62.64323911382734,
    "白城市": 84.99222395023328,
    "洮南市": 65.94982078853047,
    "大安市": 79.62145110410094,
    "延吉市": 92.09100758396532,
    "图们市": 82.15962441314555,
    "敦化市": 98.56364536899453,
    "珲春市": 80.0,
    "龙井市": 94.68822170900691,
    "和龙市": 83.85744234800839,
    "公主岭市": 67.58241758241759,
    "梅河口市": 73.11827956989248,
    "长白山保护开发区管理委员会": 9.51776649746193,
    "黑龙江": 95.18738841727178,
    "哈尔滨市": 98.26954732510288,
    "尚志市": 97.57343550446998,
    "五常市": 97.68786127167631,
    "齐齐哈尔市": 91.77330895795247,
    "讷河市": 95.53398058252426,
    "鸡西市": 96.36767976278725,
    "虎林市": 96.43366619115548,
    "密山市": 98.88888888888889,
    "鹤岗市": 98.66920152091254,
    "双鸭山市": 91.81619256017507,
    "大庆市": 98.57543859649122,
    "伊春市": 81.23366440146367,
    "铁力市": 89.50988822012039,
    "佳木斯市": 90.22033898305084,
    "同江市": 100.0,
    "富锦市": 96.81274900398408,
    "抚远市": 98.82352941176471,
    "七台河市": 98.78194411272987,
    "牡丹江市": 90.77380952380952,
    "海林市": 90.64039408866994,
    "宁安市": 100.0,
    "穆棱市": 94.27480916030534,
    "绥芬河市": 98.96432681242806,
    "东宁市": 100.0,
    "黑河市": 97.63513513513512,
    "北安市": 96.25095638867636,
    "五大连池市": 100.0,
    "绥化市": 80.24526792855238,
    "安达市": 96.6079862601975,
    "肇东市": 98.76543209876544,
    "海伦市": 93.4782608695652,
    "上海": 100.0,
    "江苏": 99.29142194699268,
    "南京市": 96.92787583688376,
    "无锡市": 100.0,
    "江阴市": 100.0,
    "宜兴市": 99.99999999999999,
    "徐州市": 99.98064734626736,
    "新沂市": 98.78520154610713,
    "邳州市": 99.1604938271605,
    "常州市": 100.0,
    "溧阳市": 100.0,
    "苏州市": 100.0,
    "常熟市": 100.0,
    "张家港市": 100.0,
    "昆山市": 100.0,
    "太仓市": 100.0,
    "南通市": 100.0,
    "海安市": 100.0,
    "启东市": 100.0,
    "如皋市": 100.0,
    "海门市": 100.0,
    "连云港市": 100.0,
    "淮安市": 99.76939856653163,
    "盐城市": 99.81380799880839,
    "东台市": 100.0,
    "扬州市": 100.0,
    "仪征市": 89.1089108910891,
    "高邮市": 99.91873222267371,
    "镇江市": 100.0,
    "丹阳市": 100.0,
    "扬中市": 100.0,
    "句容市": 100.0,
    "泰州市": 100.0,
    "兴化市": 100.0,
    "靖江市": 100.0,
    "泰兴市": 100.0,
    "宿迁市": 100.0,
    "浙江": 99.20054999017876,
    "杭州市": 100.0,
    "建德市": 100.0,
    "宁波市": 100.0,
    "余姚市": 100.0,
    "慈溪市": 81.12389213652649,
    "温州市": 100.0,
    "瑞安市": 100.0,
    "乐清市": 94.03403777819338,
    "嘉兴市": 100.0,
    "海宁市": 100.0,
    "平湖市": 100.0,
    "桐乡市": 100.0,
    "湖州市": 100.0,
    "绍兴市": 100.0,
    "诸暨市": 100.0,
    "嵊州市": 100.0,
    "金华市": 100.0,
    "兰溪市": 100.0,
    "义乌市": 100.0,
    "东阳市": 91.74768792980791,
    "永康市": 100.0,
    "衢州市": 89.7112419400056,
    "江山市": 100.0,
    "舟山市": 100.0,
    "台州市": 100.0,
    "玉环市": 100.0,
    "温岭市": 100.0,
    "临海市": 100.0,
    "丽水市": 100.0,
    "龙泉市": 100.0,
    "安徽": 97.73371456986574,
    "合肥市": 99.82527257478334,
    "巢湖市": 100.0,
    "芜湖市": 99.99999999999997,
    "蚌埠市": 93.08084486525856,
    "淮南市": 99.9066372432524,
    "马鞍山市": 100.0,
    "淮北市": 83.68524590163935,
    "铜陵市": 100.0,
    "安庆市": 100.0,
    "潜山市": 96.40718562874252,
    "桐城市": 95.54140127388536,
    "黄山市": 99.90150209308052,
    "滁州市": 99.99999999999999,
    "天长市": 95.42217700915565,
    "明光市": 100.0,
    "阜阳市": 92.08728234516201,
    "界首市": 91.88759278897136,
    "宿州市": 91.60041479433114,
    "六安市": 99.70370370370371,
    "亳州市": 99.45205479452054,
    "池州市": 99.61302805546597,
    "宣城市": 99.55269779144533,
    "宁国市": 99.16666666666667,
    "福建": 99.57209543568466,
    "福州市": 99.90023610787802,
    "福清市": 99.94461368042094,
    "厦门市": 100.0,
    "莆田市": 99.8702983138781,
    "三明市": 100.0,
    "永安市": 98.80068532267275,
    "泉州市": 98.11721611721612,
    "石狮市": 100.0,
    "晋江市": 99.43283582089552,
    "南安市": 100.0,
    "漳州市": 100.0,
    "龙海市": 100.0,
    "南平市": 99.85978687605159,
    "邵武市": 100.0,
    "武夷山市": 99.89648033126294,
    "建瓯市": 99.08515130190008,
    "龙岩市": 96.53736576813499,
    "漳平市": 100.0,
    "宁德市": 99.36215450035436,
    "福安市": 99.34988179669028,
    "福鼎市": 99.10112359550564,
    "江西": 97.82172446812939,
    "南昌市": 99.1501416430595,
    "景德镇市": 98.71124392977212,
    "乐平市": 93.8692886061307,
    "萍乡市": 100.0,
    "九江市": 98.92889405084527,
    "瑞昌市": 99.72801450589303,
    "共青城市": 95.3020134228188,
    "庐山市": 95.9409594095941,
    "新余市": 100.0,
    "鹰潭市": 97.54339993449067,
    "贵溪市": 88.96551724137932,
    "赣州市": 99.41340782122904,
    "瑞金市": 95.20661157024793,
    "吉安市": 94.96998551024632,
    "井冈山市": 87.50000000000001,
    "宜春市": 98.54285714285714,
    "丰城市": 91.98188598827916,
    "樟树市": 90.9813269765594,
    "高安市": 98.32526981764049,
    "抚州市": 99.5166088249876,
    "上饶市": 94.68226535495879,
    "德兴市": 87.1548619447779,
    "山东": 96.97029563635971,
    "济南市": 99.67748922958434,
    "青岛市": 99.63331382874975,
    "胶州市": 100.0,
    "平度市": 100.0,
    "莱西市": 100.0,
    "淄博市": 99.93423216047353,
    "枣庄市": 93.53675180347047,
    "滕州市": 100.0,
    "东营市": 100.0,
    "烟台市": 94.68917249897076,
    "龙口市": 99.96622762580209,
    "莱阳市": 96.09659278862057,
    "莱州市": 97.5,
    "蓬莱市": 100.0,
    "招远市": 99.99999999999997,
    "栖霞市": 73.64975450081835,
    "海阳市": 99.73076923076924,
    "潍坊市": 100.0,
    "青州市": 100.0,
    "诸城市": 81.30408532904005,
    "寿光市": 100.0,
    "安丘市": 96.39257294429709,
    "高密市": 95.85316111488783,
    "昌邑市": 87.10039259674706,
    "济宁市": 99.49283631291999,
    "曲阜市": 97.99065420560747,
    "邹城市": 96.87943262411348,
    "泰安市": 92.25976049070196,
    "新泰市": 95.67567567567568,
    "肥城市": 100.0,
    "威海市": 98.86422302529687,
    "荣成市": 100.0,
    "乳山市": 98.0952380952381,
    "日照市": 100.0,
    "莱芜市": 91.09722222222223,
    "临沂市": 85.34021843440112,
    "德州市": 96.48110221560232,
    "乐陵市": 96.7357910906298,
    "禹城市": 93.33001493280238,
    "聊城市": 96.43092466505601,
    "临清市": 94.08157007053052,
    "滨州市": 100.0,
    "邹平市": 100.0,
    "菏泽市": 94.2368449722192,
    "河南": 93.2803700803987,
    "郑州市": 98.91406761526054,
    "巩义市": 74.9719416386083,
    "荥阳市": 86.46153846153845,
    "新密市": 98.56081708449396,
    "新郑市": 90.07633587786259,
    "登封市": 85.09591736350222,
    "开封市": 93.93939393939394,
    "洛阳市": 97.42351046698874,
    "偃师市": 74.9470338983051,
    "平顶山市": 97.97822706065318,
    "舞钢市": 94.73684210526315,
    "汝州市": 54.634146341463406,
    "安阳市": 95.10526315789474,
    "林州市": 96.24826308476146,
    "鹤壁市": 97.1032231742146,
    "新乡市": 99.39209726443768,
    "卫辉市": 92.27871939736345,
    "辉县市": 78.68705035971225,
    "焦作市": 99.80024968789014,
    "沁阳市": 81.42857142857143,
    "孟州市": 98.10457516339869,
    "濮阳市": 95.94373568858357,
    "许昌市": 98.19724284199364,
    "禹州市": 85.63535911602212,
    "长葛市": 92.01213346814964,
    "漯河市": 99.80337538915288,
    "三门峡市": 92.10845811412383,
    "义马市": 84.88505747126436,
    "灵宝市": 86.41975308641977,
    "南阳市": 73.87673708481336,
    "邓州市": 90.65300896286811,
    "商丘市": 88.08043117744612,
    "永城市": 95.10729613733905,
    "信阳市": 98.04661851608665,
    "周口市": 96.2670994667285,
    "项城市": 94.25962165688193,
    "驻马店市": 87.15453483845855,
    "济源市": 99.64052287581698,
    "湖北": 97.33613555759884,
    "武汉市": 100.0,
    "黄石市": 94.10396557739271,
    "大冶市": 100.0,
    "十堰市": 99.94553376906319,
    "丹江口市": 96.87199230028874,
    "宜昌市": 99.03360893374852,
    "宜都市": 100.0,
    "当阳市": 99.36575052854124,
    "枝江市": 87.14780029658922,
    "襄阳市": 100.0,
    "老河口市": 97.265625,
    "枣阳市": 95.34375,
    "宜城市": 100.0,
    "鄂州市": 82.44507287361323,
    "荆门市": 89.6799020465279,
    "钟祥市": 98.2078853046595,
    "孝感市": 96.39247124433601,
    "应城市": 97.41474147414742,
    "安陆市": 96.45286686103013,
    "汉川市": 100.0,
    "荆州市": 98.09304997128088,
    "石首市": 98.20954907161804,
    "洪湖市": 97.2360028348689,
    "松滋市": 98.41029523088571,
    "黄冈市": 100.0,
    "麻城市": 98.53099247581511,
    "武穴市": 100.0,
    "咸宁市": 96.8054211035818,
    "赤壁市": 97.0873786407767,
    "随州市": 97.99004975124377,
    "广水市": 54.494206075790785,
    "恩施市": 98.62627685804861,
    "利川市": 92.71523178807948,
    "仙桃市": 97.53086419753086,
    "潜江市": 81.84727937814358,
    "天门市": 100.0,
    "湖南": 95.24321387911256,
    "长沙市": 100.0,
    "宁乡市": 90.9244764121007,
    "浏阳市": 100.0,
    "株洲市": 96.7725143154607,
    "醴陵市": 100.0,
    "湘潭市": 88.418735477559,
    "湘乡市": 100.0,
    "韶山市": 95.38152610441767,
    "衡阳市": 99.99999999999997,
    "耒阳市": 71.90226876090752,
    "常宁市": 93.33333333333333,
    "邵阳市": 98.27319949459496,
    "武冈市": 75.86206896551724,
    "岳阳市": 95.2914798206278,
    "汨罗市": 69.33734939759036,
    "临湘市": 75.30120481927712,
    "常德市": 100.0,
    "津市市": 100.0,
    "张家界市": 98.72918492550394,
    "益阳市": 96.88715953307393,
    "沅江市": 88.22003113648158,
    "郴州市": 91.44893111638955,
    "资兴市": 100.0,
    "永州市": 96.79721496953874,
    "怀化市": 93.42948717948717,
    "洪江市": 82.77404921700223,
    "娄底市": 98.10371517027865,
    "冷水江市": 97.44104365278476,
    "涟源市": 86.35863586358636,
    "吉首市": 100.0,
    "广东": 97.09827965970987,
    "广州市": 100.0,
    "韶关市": 99.15031670013904,
    "乐昌市": 91.1300121506683,
    "南雄市": 98.13359528487229,
    "深圳市": 100.00307064007492,
    "珠海市": 100.0,
    "汕头市": 90.58074667429553,
    "佛山市": 99.98397863818424,
    "江门市": 99.31482149296791,
    "台山市": 100.0,
    "开平市": 98.76118375774259,
    "鹤山市": 100.0,
    "恩平市": 97.40259740259741,
    "湛江市": 96.73131401176727,
    "廉江市": 97.87928221859707,
    "雷州市": 69.70428485214242,
    "吴川市": 96.79793890320207,
    "茂名市": 100.0,
    "高州市": 100.0,
    "化州市": 99.37065253395164,
    "信宜市": 100.0,
    "肇庆市": 98.65951742627345,
    "四会市": 99.79838709677419,
    "惠州市": 98.64379903188116,
    "梅州市": 100.0,
    "兴宁市": 100.0,
    "汕尾市": 92.58664955070603,
    "陆丰市": 90.2061855670103,
    "河源市": 100.0,
    "阳江市": 100.0,
    "阳春市": 99.54751131221718,
    "清远市": 151.62860351928117,
    "英德市": 98.07801017524025,
    "连州市": 83.04498269896193,
    "东莞市": 100.0,
    "潮州市": 67.33694251095643,
    "揭阳市": 91.02325581395348,
    "普宁市": 98.53012437409143,
    "云浮市": 72.8718118582312,
    "罗定市": 90.9090909090909,
    "广西": 94.24311926605505,
    "南宁市": 96.59399037131317,
    "柳州市": 77.41424513873717,
    "桂林市": 99.10185967878277,
    "荔浦市": 95.36423841059603,
    "梧州市": 91.1965676148101,
    "岑溪市": 86.23595505617978,
    "北海市": 98.47266881028939,
    "防城港市": 100.0,
    "东兴市": 97.48743718592962,
    "钦州市": 96.0,
    "贵港市": 100.0,
    "桂平市": 95.28897523069452,
    "玉林市": 100.0,
    "北流市": 97.86324786324785,
    "百色市": 100.0,
    "靖西市": 100.0,
    "贺州市": 99.11330049261086,
    "河池市": 100.0,
    "来宾市": 99.90952955367914,
    "合山市": 96.2897526501767,
    "崇左市": 99.47643979057591,
    "凭祥市": 94.72361809045226,
    "海南": 96.68959117952079,
    "海口市": 97.01040063429878,
    "三亚市": 98.2256020278834,
    "三沙市": 100.0,
    "儋州市": 90.63260340632604,
    "五指山市": 80.22922636103151,
    "琼海市": 99.99999999999997,
    "文昌市": 100.0,
    "万宁市": 92.59259259259258,
    "东方市": 97.81357882623703,
    "重庆": 96.77049202074738,
    "重庆市": 96.77049202074738,
    "四川": 93.69930994093465,
    "成都市": 98.9426829122761,
    "都江堰市": 98.77262964099415,
    "彭州市": 98.07422969187675,
    "邛崃市": 99.61915125136015,
    "崇州市": 94.95708154506437,
    "简阳市": 86.95652173913044,
    "自贡市": 84.98281786941581,
    "攀枝花市": 73.85501971489234,
    "泸州市": 89.90553806260418,
    "德阳市": 93.02220208427731,
    "广汉市": 75.07383343177791,
    "什邡市": 74.96251874062969,
    "绵竹市": 97.897026831037,
    "绵阳市": 99.95007132667618,
    "江油市": 98.1767180925666,
    "广元市": 90.52867550906034,
    "遂宁市": 99.66930001837223,
    "内江市": 92.00428069102584,
    "隆昌市": 96.81383705052345,
    "乐山市": 96.60098522167488,
    "峨眉山市": 92.69823160296635,
    "南充市": 98.54014598540147,
    "阆中市": 98.4375,
    "眉山市": 97.82608695652173,
    "宜宾市": 86.80453738714407,
    "广安市": 99.1390906645144,
    "华蓥市": 96.09958506224065,
    "达州市": 85.86525759577277,
    "万源市": 91.39375476009138,
    "雅安市": 99.20347574221577,
    "巴中市": 84.49781659388648,
    "资阳市": 84.33734939759036,
    "马尔康市": 93.17406143344711,
    "康定市": 70.58823529411765,
    "西昌市": 75.87043131820543,
    "贵州": 96.67808044155977,
    "贵阳市": 98.90843142622502,
    "清镇市": 97.72951628825271,
    "六盘水市": 90.6032805115374,
    "盘州市": 91.0185185185185,
    "遵义市": 95.28301886792453,
    "赤水市": 93.38786639400136,
    "仁怀市": 96.56412305233721,
    "安顺市": 98.94600989460099,
    "毕节市": 95.75229152693942,
    "铜仁市": 95.00241429261227,
    "兴义市": 95.77970667464832,
    "兴仁市": 95.69657184536833,
    "凯里市": 96.26008310926424,
    "都匀市": 94.06211936662606,
    "福泉市": 98.05970149253733,
    "云南": 95.8454507685916,
    "昆明市": 98.24609895218232,
    "安宁市": 100.0,
    "曲靖市": 96.2776025236593,
    "宣威市": 99.13822819717339,
    "玉溪市": 99.11619443722383,
    "保山市": 89.62025316455696,
    "腾冲市": 83.33333333333334,
    "昭通市": 100.0,
    "丽江市": 100.0,
    "普洱市": 92.54385964912281,
    "临沧市": 72.84836065573771,
    "楚雄市": 98.21316614420063,
    "个旧市": 99.00990099009901,
    "开远市": 88.62512363996044,
    "蒙自市": 95.49795361527967,
    "弥勒市": 90.22118742724098,
    "文山市": 98.12286689419795,
    "景洪市": 100.0,
    "大理市": 99.96813256851499,
    "瑞丽市": 100.0,
    "芒市": 93.89671361502347,
    "泸水市": 37.651821862348186,
    "香格里拉市": 76.62061636556854,
    "西藏": 85.90149118843199,
    "拉萨市": 78.71747211895912,
    "日喀则市": 99.99999999999997,
    "昌都市": 91.74311926605505,
    "林芝市": 96.49122807017544,
    "山南市": 90.1639344262295,
    "那曲市": 81.78438661710038,
    "陕西": 89.34745769786215,
    "西安市": 97.36281345357224,
    "铜川市": 96.78199854827002,
    "宝鸡市": 87.32646663681147,
    "咸阳市": 65.71205160785847,
    "彬州市": 99.91235758106924,
    "兴平市": 28.786536758193094,
    "渭南市": 84.49963741841916,
    "韩城市": 79.21478060046189,
    "华阴市": 87.87878787878789,
    "延安市": 89.99280057595392,
    "汉中市": 81.87884108867428,
    "榆林市": 83.61590873078752,
    "神木市": 96.3302752293578,
    "安康市": 94.01197604790418,
    "商洛市": 75.42857142857143,
    "杨凌区": 96.19109102646868,
    "甘肃": 95.32895551976212,
    "兰州市": 91.20575446011298,
    "嘉峪关市": 100.0,
    "金昌市": 77.20116618075804,
    "白银市": 100.0,
    "天水市": 98.93769738730978,
    "武威市": 99.97050147492625,
    "张掖市": 94.22863485016649,
    "平凉市": 100.0,
    "华亭市": 97.9955456570156,
    "酒泉市": 100.0,
    "玉门市": 100.0,
    "敦煌市": 100.0,
    "庆阳市": 100.0,
    "定西市": 98.42256214149138,
    "陇南市": 96.85459940652818,
    "临夏市": 99.99999999999999,
    "合作市": 82.64462809917356,
    "青海": 96.6778958279347,
    "西宁市": 97.66820139610873,
    "海东市": 95.07235041063747,
    "玉树市": 86.23548922056385,
    "格尔木市": 97.82135076252723,
    "德令哈市": 99.27431059506532,
    "宁夏": 95.47831955458074,
    "银川市": 100.0,
    "灵武市": 93.6123348017621,
    "宁东能源化工基地": 100.0,
    "石嘴山市": 79.63779893197122,
    "吴忠市": 97.12820512820514,
    "青铜峡市": 86.53175157013258,
    "固原市": 96.49749821300931,
    "中卫市": 96.80968096809683,
    "新疆": 97.20946195680868,
    "乌鲁木齐市": 99.47638496177612,
    "克拉玛依市": 100.0,
    "吐鲁番市": 99.99999999999997,
    "哈密市": 97.51729751729752,
    "昌吉市": 100.0,
    "阜康市": 85.43956043956044,
    "博乐市": 100.0,
    "阿拉山口市": 98.21428571428571,
    "库尔勒市": 98.3874260053072,
    "阿克苏市": 99.80472987632893,
    "阿图什市": 100.0,
    "喀什市": 100.0,
    "和田市": 98.21018815970628,
    "伊宁市": 92.86097691894794,
    "奎屯市": 99.02690326273613,
    "霍尔果斯市": 93.33333333333333,
    "塔城市": 95.28688524590166,
    "乌苏市": 94.74727452923688,
    "阿勒泰市": 88.31710709318497,
    "石河子市": 100.0,
    "阿拉尔市": 97.91666666666666,
    "图木舒克市": 86.36363636363637,
    "五家渠市": 53.475935828877006,
    "北屯市": 83.95989974937343,
    "铁门关市": 100.0,
    "双河市": 84.0,
    "昆玉市": 100.0
}